import { Fragment, ReactNode } from 'react';
import DocReference from './DocReference';

type Props = {
  content: string;
};

// Inline `:documentation{id=…}` references the composer folds into a sent
// message (see ChatInput). The block (`::`) form never reaches a user message.
const DOC_DIRECTIVE = /:documentation\{id=([^}]+)\}/g;

// Renders a user message as literal text — user input is NOT markdown — but
// swaps any `:documentation{id=…}` reference for the same resolved inline chip
// the assistant uses, so an attached document reads as a chip rather than raw
// directive text in the sent bubble.
function UserMessageContent({ content }: Props) {
  const segments: ReactNode[] = [];
  let cursor = 0;
  let key = 0;

  Array.from(content.matchAll(DOC_DIRECTIVE)).forEach((match) => {
    const start = match.index ?? 0;
    if (start > cursor) {
      segments.push(
        <Fragment key={key}>{content.slice(cursor, start)}</Fragment>,
      );
      key += 1;
    }
    segments.push(<DocReference key={key} id={match[1]} inline />);
    key += 1;
    cursor = start + match[0].length;
  });

  if (cursor < content.length) {
    segments.push(<Fragment key={key}>{content.slice(cursor)}</Fragment>);
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{segments}</>;
}

export default UserMessageContent;
